export const customerOrderType = {
    "CUT": "Распил",
    "CUT_PROCESSING": "Распил с обработкой",
    // "CUT_PROCESSING_ACCESSORIES": "Распил с обработкой и фурнитурой",
}